import React, {useContext} from 'react';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import {Controller, useFormContext} from 'react-hook-form';
import CustomSelect from '@src/components/Fields/CustomSelect';
import classnames from '@src/helpers/classnames';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import {FormDataProviderAPIContext} from '@src/contexts/FormDataProviderAPIContext';

export default function ManagerField() {
    const {control} = useFormContext();
    const [design] = useContext(FormFieldDesignContext);
    const fromData = useContext(FormDataProviderAPIContext);

    return <>
        <Controller
                control={control}
                name="manager"
                render={({field: {name, value, onChange, onBlur}, fieldState: {error}}) => {
                    return <CustomSelect
                            label="OrdersShow.fields.manager"
                            className={classnames({
                                'is-invalid': Boolean(error)
                            })}
                            name={name}
                            size={design.size as any}
                            options={fromData?.modelOptions?.manager ?? []}
                            readOnly={design.fieldsAreReadOnly}
                            disabled={design.fieldsAreDisabled}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            menuPortalTarget={document.body}
                    />;
                }}
        />

        <FormErrorMessage fieldName="manager"/>
    </>;
}
